import { render, staticRenderFns } from "./PurchaseOrderList.vue?vue&type=template&id=eb648aa4&scoped=true&"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderList.vue?vue&type=style&index=0&id=eb648aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb648aa4",
  null
  
)

export default component.exports